<template>
    <div>
        <div v-for="detail in post.details" :key="detail.id">
            <div class="mb-1" v-if="detail.field == 'satisfaction'">
                <span class="field">{{ $t(`feed.fields.${detail.field}`) }}</span> <br />
                <div class="mb-2">
                    <span class="mr-1"> {{ $t('feed.from') }}: </span>
                    <span class="mr-1">
                        <i :class="['fa fa-lg', smileIconClass(detail.from)]" :title="$t(smileStatus(detail.from))"></i>
                    </span>
                    <span class="mr-1"> {{ $t('feed.to') }}: </span>
                    <span>
                        <i :class="['fa fa-lg', smileIconClass(detail.to)]" :title="$t(smileStatus(detail.to))"></i>
                    </span>
                </div>
            </div>
            <div class="mb-1" v-else>
                <div v-if="detail.field == 'evidence'">
                    <span class="field">{{ $t('checkIn.evidences') }} </span>
                    <div class="mb-2">
                        <span class="field mr-1">{{ $t('feed.from') }}:</span>
                        <span class="mr-2">
                            <b-link
                                @click="download(post.kpi_checkin.id, getFileNameFromURL(detail.from))"
                                :title="getFileNameFromURL(detail.from)"
                                >{{ getFileNameFromURL(detail.from) }}</b-link
                            >
                        </span>
                        <span class="field mr-1">{{ $t('feed.to') }}:</span>
                        <span>
                            <b-link
                                @click="download(post.kpi_checkin.id, getFileNameFromURL(detail.to))"
                                :title="getFileNameFromURL(detail.to)"
                                >{{ getFileNameFromURL(detail.to) }}</b-link
                            >
                        </span>
                    </div>
                </div>
                <div v-else-if="detail.field == 'reference_type'">
                    <span class="field">{{ $t(`feed.fields.${detail.field}`) }}</span>
                    <div class="mb-2">
                        <span class="field mr-1">{{ $t('feed.from') }}:</span>
                        <span v-html="$t(`form.referenceType.types.${detail.from}`)" class="mr-2" />
                        <span class="field mr-1">{{ $t('feed.to') }}:</span>
                        <span v-html="$t(`form.referenceType.types.${detail.to}`)" />
                    </div>
                </div>
                <div v-else-if="detail.field == 'description'">
                    <BaseDescription :detail="detail" />
                </div>
                <div class="mb-1" v-else>
                    <span class="field">{{ $t(`feed.fields.${detail.field}`) }}</span>
                    <div class="mb-2">
                        <span class="field">{{ $t('feed.from') + ': ' }}</span>
                        <span class="mr-2">{{ detail.from }}</span>
                        <span class="field">{{ ' ' + $t('feed.to') + ' : ' }}</span>
                        <span>{{ detail.to }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { smilesClassesTargetMixin, downloadEvidenceMixin } from '@/mixins'
import { BaseDescription } from '../base'

export default {
    name: 'Update',
    props: {
        post: {
            type: Object,
            required: true,
        },
    },
    mixins: [smilesClassesTargetMixin, downloadEvidenceMixin],
    components: {
        BaseDescription,
    },
}
</script>

<style></style>
